// extracted by mini-css-extract-plugin
export var cancelButton = "_lu-5";
export var content = "_lu-3";
export var createButton = "_lu-6";
export var drawerContainer = "_lu-0";
export var footer = "_lu-2";
export var header = "_lu-1";
export var orderFormColumn = "_lu-4";